<div class="p-fluid w-[96rem] ">
  <p class="text-xl text-start font-semibold">
     Sono presenti delle attività in sospeso!
  </p>
    <p>

    Per proseguire, esita tutte le attività della giornata precedente, riportate nella lista qui di seguito. Una volta terminato, aggiorna
    questa pagina e potrai continuare ad utilizzare tutte le funzionalità del CRM.
  </p>

  <div class="w-full h-[38rem]">
    <appointments-list [initialForm]="initialForm" [filterLess]="true"></appointments-list>
  </div>
</div>
